import { shopScene } from '../shopkit.js';

/** 衙门大堂：办证、缴辎的计划、领榜文任务的地方。 */
export const yamenHallDoc = shopScene({
  id: 'yamen_hall',
  name: '衙门大堂',
  shop: 'yamen',
  owner: '知县',
  desc: '堂上高悬「明镜高悬」二字，两边站着差役。',
  w: 26, h: 20,
  floor: '~',
  counters: [{ gx: 10, gy: 4, len: 6, kind: 'yamen' }],
  props: [
    { type: 'magistrate_seat', gx: 13, gy: 2 },
    { type: 'sealed_desk', gx: 18, gy: 7 },
    { type: 'locked_ledger', gx: 21, gy: 9 },
    { type: 'notice_board', gx: 4, gy: 10 },
    { type: 'incense_burner', gx: 13, gy: 12 },
  ],
  portals: [
    { to: 'yamen_sq', gx: 13, gy: 19, spawn: [22, 10], label: '回衙前广场' },
  ],
});

export default yamenHallDoc;
